import React from "react";
import useNotificationCenterState from "features/metadesk/Notification/NotificationCenter/NotificationCenter.hooks";
import NotificationCenterContext from "features/metadesk/Notification/NotificationCenter/NotificationCenter.context";
import NotificationCenterContent from "features/metadesk/Notification/NotificationCenter/components/NotificationCenterContent";

const NotificationCenterContainer = () => {
  const {
    searchText,
    selectedItems,
    handleSetSelectedItems,
    handleClearSelectedItems,
    notificationList,
    setNotificationList,
    page,
    handleChangePage,
    totalItems,
    handleSearchChange,
    handleCategoryChange,
    renderContents,
    order,
    orderBy,
    handleRequestSort,
    actionsList,
    loading,
    anchorEl,
    handleCloseActions,
  } = useNotificationCenterState();

  return (
    <NotificationCenterContext.Provider
      value={{
        searchText,
        selectedItems,
        handleSetSelectedItems,
        handleClearSelectedItems,
        notificationList,
        setNotificationList,
        page,
        handleChangePage,
        totalItems,
        handleSearchChange,
        handleCategoryChange,
        renderContents,
        order,
        orderBy,
        handleRequestSort,
        actionsList,
        loading,
        anchorEl,
        handleCloseActions,
      }}
    >
      <NotificationCenterContent></NotificationCenterContent>
    </NotificationCenterContext.Provider>
  );
};

export default NotificationCenterContainer;
